module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Purchased: His Perfect Wife")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/01.jpg"
    }
  })])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_vm._v("Welcome to the October 2008 collection of Harlequin Presents!")])]), _c('p', {
    staticClass: "paraNoIndent0"
  }, [_c('span', [_vm._v("This month read Sandra Marton’s "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Sheikh’s Defiant Bride,")])]), _vm._v(" the first book in her exciting trilogy THE SHEIKH TYCOONS. We also visit the Mediterranean, and two affluent heroes who aren’t afraid to take what they want, in Julia James’s "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Greek Tycoon, Waitress Wife")])]), _vm._v(" and Robyn Donald’s "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("His Majesty’s Mistress.")])]), _vm._v(" Things begin to heat up at work (or should we say "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("after")])]), _vm._v(" work) for Abby in Anne Oliver’s "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Business in the Bedroom.")])]), _vm._v(" Maggie Cox also brings you a sexy office tale, this time involving an Italian tycoon and his unsuspecting personal assistant, in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Secretary Mistress, Convenient Wife.")])]), _vm._v(" Helen Bianchin weaves a story of attraction and convenience in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Purchased: His Perfect Wife,")])]), _vm._v(" in which cash-strapped Lara finds herself making a deal with her brooding stepbrother. Innocence is lost and passion abounds in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("One Night with His Virgin Mistress")])]), _vm._v(" by Sara Craven, and housekeeper Liv’s job description is more hands-on than most in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Housekeeper at His Beck and Call,")])]), _vm._v(" compliments of Susan Stephens.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("We’d love to hear what you think about Harlequin Presents. E-mail us at Presents@hmb.co.uk, or join in the discussions at www.iheartpresents.com and www.sensationalromance.blogspot.com, where you’ll also find more information about books and authors!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9d491ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchasedhisperfectwife_fm01.vue
// module id = 57
// module chunks = 0